import React from 'react';
import classNames from 'classnames';
import { LAYOUT } from '@wix/live-video-commons';
import { useExternalUserId } from '../../../session-provider';
import { useVideoConfig } from '../../../video-config-provider';
import s from './name.scss';
export const Name = ({ attendeeId, focused }) => {
    const { getParticipantName, dashboard, knownClients = [], texts, mobile, sidePanelOpened, layout, recorder, } = useVideoConfig();
    const externalUserId = useExternalUserId(attendeeId);
    const host = knownClients.find(({ clientId, isHost }) => attendeeId === clientId && isHost);
    const name = getParticipantName(externalUserId) || '';
    if (mobile && (layout === LAYOUT.GRID || !focused)) {
        return null;
    }
    return (React.createElement("div", { className: classNames(s.container, {
            [s.dashboardContainer]: dashboard,
            [s.mobile]: mobile,
            [s.sidePanelOpened]: sidePanelOpened,
            [s.recorderFonts]: recorder,
        }) }, `${name}${host ? ` ${texts.host}` : ''}`));
};
//# sourceMappingURL=name.js.map